"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequired = void 0;
function isRequired(...args) {
    if (args.length === 0) {
        throw new Error('Argument required!');
    }
    args.forEach((arg) => {
        if (!arg && arg !== false) {
            throw new Error('Argument required!');
        }
    });
}
exports.isRequired = isRequired;
